import { ISubscriptionsStore } from '@/store/modules/subscriptions/index';
import { ISubscription } from '@/bundles/Subscriptions/interfaces/ISubsription';

import { SubscriptionsActions } from './subscription-types';

export default {
  [SubscriptionsActions.SET_SUBSCRIPTIONS] (state: ISubscriptionsStore, subscriptions: ISubscription[]) {
    state.subscriptions = [...subscriptions];
  },
}
